import React from "react";
import Button from "react-bootstrap/Button";
// import Row from "react-bootstrap/Row";

function Header({ title, showHome, parentEvent }) {
  const handleClick = (event) => {
    event.preventDefault();
    parentEvent();
  };

  return (
      <div className="header">
        <img src="images/shell-pecten.jpg" alt="" width={248} height={202} />
        <div className="headingText">
          <h1>Decarbonising cities, ports and industries.</h1>
          <h2>{title}</h2>
        </div>
        {showHome && (
          <Button className="home_button icon--home" type="button" onClick={handleClick}>
            
          </Button>
        )}
      </div>
  );
}

export default Header;
